/** Variant IDs that must not appear in recently viewed (e.g. fee / internal SKU). */
const EXCLUDED_RECENT_VARIANT_IDS = new Set([45929630040164, '45929630040164']);

function isExcludedRecentVariantId(v) {
  if (v == null || v === '') return false;
  return EXCLUDED_RECENT_VARIANT_IDS.has(v) || EXCLUDED_RECENT_VARIANT_IDS.has(Number(v));
}

class RecentlyProducts extends HTMLElement {
    constructor() {
      super();
      this.recentlyViewed = [];
      this.container = Utility.DomSelector.$('.recently-viewed-main');

      this.manageRecentlyViewed();
    }
    
    manageRecentlyViewed(){
      let getRecentlyViewed = Utility.Storage.Local.get("user_recently_viewed");
      if (getRecentlyViewed != null) {
        let raw = JSON.parse(getRecentlyViewed);
        const beforeLen = raw.length;
        raw = raw.filter((p) => {
          if (isExcludedRecentVariantId(p.selected_variant_id)) return false;
          const vc = parseInt(p.variants_count, 10);
          if (!isNaN(vc) && vc === 1 && isExcludedRecentVariantId(p.first_variant_id)) return false;
          return true;
        });
        if (raw.length !== beforeLen) {
          Utility.Storage.Local.set('user_recently_viewed', JSON.stringify(raw));
        }
        this.recentlyViewed = raw;
        this.recentlyViewed.reverse();

        if(this.recentlyViewed.length > 0) this.showRecentlyViewed(this.recentlyViewed);
      }
      
      if(globalThis.themeData.template === 'product'){
        const productData = globalThis.themeData.product;
        // Ensure we get the correct variant count and first variant ID
        const variants = productData.variants || [];
        const variantsCount = Array.isArray(variants) ? variants.length : 1;
        const firstVariantId = Array.isArray(variants) && variants.length > 0 ? variants[0].id : productData.id;
        const selectedVariantId = productData.selected_or_first_available_variant?.id ?? firstVariantId;

        if (isExcludedRecentVariantId(selectedVariantId)) {
          return;
        }

        let requiredData = {
          id: productData.id,
          handle: productData.handle,
          title: productData.title,
          price: productData.price,
          compared_at_price: productData.compare_at_price,
          image: productData.featured_image,
          vendor: productData.vendor,
          type: productData.type,
          variants_count: variantsCount,
          first_variant_id: firstVariantId,
          selected_variant_id: selectedVariantId,
          available: productData.available
        }
        this.addToRecentlyViewed(requiredData);
      }
    }

    showRecentlyViewed(products) {
      let recentlyViewedHTML = '';
      let totalProducts = 0;
      const isLoggedIn = document.body.classList.contains('customer-logged-in');
      const placeholderImage = this.container?.dataset?.placeholderImage || '';
      const placeholderTemplate = this.container?.querySelector('[data-recently-placeholder-template]');
      
      const getDisplayTitle = (title) => {
        const str = (title || '');
        const display = str.split(' : ')[0].trim();
        return display || str;
      };

      const resolveImageSrc = (image) => {
        if (typeof image !== 'string') return placeholderImage;
        const normalized = image.trim();
        if (!normalized || normalized === 'null' || normalized === 'undefined') return placeholderImage;
        return normalized;
      };

      products.forEach(product => {
        const currentProduct = globalThis.themeData.product?.id || '123';
        const currentIndex = product.id == currentProduct;
        const displayTitle = getDisplayTitle(product.title);
        const productImageSrc = resolveImageSrc(product.image);
        const hasValidProductImage = !!productImageSrc && !productImageSrc.includes('animated-placeholder.svg');
        const productImageMarkup = hasValidProductImage
          ? `<img src="${productImageSrc}" title="${displayTitle}" alt="${displayTitle}" width="100%" height="100%" loading="lazy"/>`
          : (placeholderTemplate?.innerHTML || `<img src="${placeholderImage}" title="${displayTitle}" alt="${displayTitle}" width="100%" height="100%" loading="lazy"/>`);
        if(currentIndex === false){
          totalProducts += 1;
          
          // Determine button type based on variant count
          let actionButton = '';
          if (isLoggedIn) {
            // variants_count should be a number, but could be string from localStorage
            const variantsCount = parseInt(product.variants_count, 10);
            const hasValidVariantId = !!product.first_variant_id;
            // Single variant: has valid variant ID AND variants_count equals 1
            // For legacy data without variants_count, show Choose Options (safer fallback)
            const isSingleVariant = hasValidVariantId && !isNaN(variantsCount) && variantsCount === 1;
            
            if (isSingleVariant) {
              // Single variant with valid variant ID: Show Add to Cart button (inside image overlay like home page)
              const variantId = product.first_variant_id;
              const isAvailable = product.available !== false;
              const typeAttr =
                product.type && String(product.type).trim()
                  ? ` data-product-type="${String(product.type)
                      .replace(/&/g, '&amp;')
                      .replace(/"/g, '&quot;')
                      .replace(/</g, '&lt;')}"`
                  : '';
              actionButton = `
                <div class="button_show_hover bottom_image mt-3 mt-md-0">
                  <div class="product_buy_buttons d-flex flex-column">
                    <form class="form d-flex flex-row gap-2" onsubmit="return false;">
                      <button type="button" 
                        class="btn btn-primary btn-sm flex-grow-1 border-0 recently-viewed-add-to-cart ${!isAvailable ? 'disabled' : ''}"
                        data-variant-id="${variantId}"
                        data-product-handle="${product.handle}"${typeAttr}
                        ${!isAvailable ? 'disabled' : ''}
                        aria-label="${isAvailable ? 'Add ' + displayTitle + ' to cart' : displayTitle + ' is sold out'}">
                        <span class="add-text">${isAvailable ? 'Add to Cart' : 'Sold Out'}</span>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </button>
                    </form>
                  </div>
                </div>`;
            } else {
              // Multi-variant OR legacy data without variant info: Show Quick View button (inside image overlay)
              actionButton = `
                <div class="button_show_hover bottom_image mt-3 mt-md-0">
                  <div class="product_buy_buttons d-flex flex-column">
                    <form class="form d-flex flex-row gap-2" onsubmit="return false;">
                      <quick-shop-button class="btn btn-primary btn-sm flex-grow-1 quickshop--button" 
                        data-handle="${product.handle}"
                        aria-label="Choose Options for ${displayTitle}">
                        <span class="add-text">Choose Options</span>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </quick-shop-button>
                    </form>
                  </div>
                </div>`;
            }
          }
          
          recentlyViewedHTML += ` <swiper-slide>
            <div class="card card-product card-product-style-1 square text-start rounded-0 border-0">
              <div class="card-img product--media text-center mb-md-4 mb-2 position-relative">
                <button type="button" class="wishlist-btn swym-add-to-wishlist position-absolute border-0" data-product-id="${product.id}" data-variant-id="${product.selected_variant_id || product.first_variant_id || ''}" data-product-url="${window.location.origin}/products/${product.handle}" aria-label="Add to wishlist">
                  <svg class="wishlist-icon-empty" aria-hidden="true" focusable="false"><use href="#icon-wishlist"></use></svg>
                  <svg class="wishlist-icon-hover position-absolute" aria-hidden="true" focusable="false"><use href="#icon-hover-wishlist"></use></svg>
                  <svg class="wishlist-icon-filled text-black position-relative z-1 d-none" aria-hidden="true" focusable="false"><use href="#icon-filled-wishlist"></use></svg>
                </button>
                <a href="/products/${product.handle}" class="d-block product-link position-relative">
                ${productImageMarkup}</a>
              </div>
              <div class="card-body d-flex flex-column p-0">
                <p class="text-block fs-md fw-bolder text-uppercase mb-md-1 mb-1" style="color:#145791">${product.vendor || ''}</p>
                <a href="/products/${product.handle}" class="link-product-title d-block fs-base fw-semibold text-capitalize mb-md-3 mb-2" style="color: #333333; flex: 1 1 0; line-height: 1.4;">
                  <span class="product-title-clamp">${displayTitle}</span>
                </a>
                ${isLoggedIn ? `<p class="mb-0">
                  <span class="price m-0 p-0 money d-inline-block fs-base fw-bolder discounted-price" style="color:#333333">${Utility.formatMoney(product.price, globalThis.themeData.money_format)}</span>
                </p>` : ''}
              </div>
              ${actionButton}
            </div>
          </swiper-slide>`;
        }
      });

      if(totalProducts > 0){
        let sliderHTML = `
        <div class="custom-swiper-navigation inside show_only_desktop arrow-center-image">
          <button class="swiper-button-prev button-prev-recently-viewed">
            <svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg>
          </button>
          <button class="swiper-button-next button-next-recently-viewed">
            <svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg>
          </button> 
        </div>

        <swiper-container class="recentlyViewe--swiper"
          slides-per-view="1.7"
          space-between="15"
          loop="false"
          grab-cursor="true"
          navigation='{
            "nextEl": ".button-next-recently-viewed",
            "prevEl": ".button-prev-recently-viewed"
          }'
          breakpoints='{
            "560": {
              "slidesPerView": 2,
              "spaceBetween": 20
            },
            "768": {
              "slidesPerView": 3,
              "spaceBetween": 20
            },
            "1200": {
              "slidesPerView": 4,
              "spaceBetween": 30
            }
          }'
          >${recentlyViewedHTML}</swiper-container>`

        this.container.classList.remove('d-none');
        this.container.querySelector("recently-products").innerHTML = sliderHTML;

        // Rebind Swym handlers for dynamically injected Recently Viewed cards.
        if (typeof window.initSwymWishlistButtons === 'function') {
          window.initSwymWishlistButtons();
        }
        
        // Trigger product media height update for nav positioning (--product-media-height, --nav-opacity)
        document.dispatchEvent(new CustomEvent('product-media-height-update'));
        
        // Setup add to cart handlers for single variant products
        this.setupAddToCartHandlers();
      }
    }

    /**
     * Setup click handlers for Add to Cart buttons
     */
    setupAddToCartHandlers() {
      const addToCartButtons = this.container.querySelectorAll('.recently-viewed-add-to-cart');
      
      addToCartButtons.forEach(button => {
        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const variantId = button.dataset.variantId;
          
          if (!variantId) return;
          
          // Show loading state (uses theme's .btn.loading to show spinner, hide text)
          button.disabled = true;
          Utility.Animate.setLoading(button, true);
          
          try {
            // Get cart drawer and section ID
            const cartDrawer = document.getElementById('component-cart-drawer');
            const cartElement = cartDrawer?.querySelector('cart-form') || Utility.DomSelector.$('cart-form');
            const cartSectionId = cartElement?.dataset?.sectionId || 'template-cart';
            
            // Add to cart with sections parameter
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            formData.append('sections', cartSectionId);
            const productType = button.getAttribute('data-product-type')?.trim();
            if (productType) {
              formData.append(
                `properties[${Utility.Cart.LINE_ITEM_PROPERTY_PRODUCT_TYPE}]`,
                productType
              );
            }
            
            const response = await fetch(`${routes.cart_add_url}.js`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json'
              },
              body: formData
            });
            
            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.description || 'Failed to add item to cart');
            }
            
            const result = await response.json();
            
            // Parse cart section HTML
            const cartHTML = result.sections?.[cartSectionId];
            const parsedCartHTML = cartHTML ? Utility.DOM.parse(cartHTML) : null;
            
            // Publish cart update event with section data to trigger drawer open
            if (typeof eventBus !== 'undefined' && parsedCartHTML) {
              eventBus.publish(THEME_EVENTS.cartUpdate, {
                data: {
                  action: 'add-item',
                  item: result,
                  section: parsedCartHTML,
                  elementToFocus: button
                }
              });
            } else {
              // Fallback: Update cart manually if no cart element
              const cartResponse = await fetch(`${routes.cart_fetch_url}.js`);
              const cartData = await cartResponse.json();
              globalThis.themeData.cart = cartData;
              Utility.Cart.updateHeaderCount();
              Utility.handleSuccess(result.title, 'Added to Cart');
            }
            
          } catch (error) {
            const message = error.message || 'Failed to add item to cart';
            Utility.handleError(message, 'Add to Cart');
          } finally {
            // Reset button state
            button.disabled = false;
            Utility.Animate.setLoading(button, false);
          }
        });
      });
    }

    addToRecentlyViewed(product) {
      const productExist = this.recentlyViewed.findIndex((x) => {
        return x.id == product.id;
      });

      if (productExist == -1) {
        this.recentlyViewed.push(product)
        Utility.Storage.Local.set(
          'user_recently_viewed',
          JSON.stringify(this.recentlyViewed)
        );
      } else {
        // Update existing product with new data (in case variants/availability changed)
        this.recentlyViewed[productExist] = { ...this.recentlyViewed[productExist], ...product };
        Utility.Storage.Local.set(
          'user_recently_viewed',
          JSON.stringify(this.recentlyViewed)
        );
      }
    }

    /**
     * Lifecycle callback when element is disconnected from DOM
     * Cleans up references
     */
    disconnectedCallback() {
      // Clean up references
      this.recentlyViewed = null;
      this.container = null;
    }
}
customElements.define("recently-products", RecentlyProducts);
